<script>
import {mapActions, mapMutations} from "vuex";

export default {
	name: "GameSelect",
	data() {
		return {
			gameSpot: '',
		}
	},
	methods: {
		startGame() {
			this.closeModal('game-select')
			this.setGameSpot(this.gameSpot)
			this.openModal('game')
		},
		...mapMutations({
			setGameSpot: 'game/setGameSpot',
		}),
		...mapActions({
			openModal: 'modals/openModal',
			closeModal: 'modals/closeModal',
		})
	},
}
</script>

<template>
	<div class="modal-form">
		<div class="modal-form__title">Узнать за 60 секунд</div>
		<div class="modal-form__subtitle">На картинке спрятаны предметы, которые «Фианит-Ломбард» с легкостью превращает в деньги. Найдите их за 1 минуту. <br> Выигрывайте и получите промокод на пониженную ставку 0.2% </div>
		<div class="game">
			<div class="game-location">
				<div class="game-location__list">
					<div class="game-location__item" :class="{active: gameSpot === 'room'}" @click="gameSpot = 'room'">
						<img src="/local/templates/.default/img/game/game-icon-0.png" alt="Комната" loading="lazy">
						<span>Комната</span>
					</div>
					<div class="game-location__item" :class="{active: gameSpot === 'garage'}" @click="gameSpot = 'garage'">
						<img src="/local/templates/.default/img/game/game-icon-1.png" alt="Гараж" loading="lazy">
						<span>Гараж</span>
					</div>
				</div>
				<div v-if="gameSpot" class="game-location__btn">
					<button class="btn color" @click.prevent="startGame">Начать игру</button>
				</div>
			</div>
		</div>
	</div>
</template>
